import {
  groupCreatorIdsByHandle,
  removeCreatorHandleFromScope,
} from "../lib/creatorScope";
import CreatorAvatar from "./CreatorAvatar";
import CreatorHoverCard from "./CreatorHoverCard";

/**
 * Who the composer is asking. Mentioning a creator adds a chip; dropping the
 * chip widens the question back out. `+ id` takes a corpus id as it is, for a
 * creator the directory doesn't answer to by name.
 */
export default function CreatorScopeBar({
  creatorIds = [],
  onChange,
  className = "",
}) {
  const groups = groupCreatorIdsByHandle(creatorIds);
  if (groups.length === 0) return null;

  return (
    <div
      role="group"
      aria-label="Creator scope"
      className={"flex flex-wrap items-center gap-1.5 " + className}
    >
      <span className="text-[12px] font-medium text-ink-400">Asking</span>
      {groups.map((group) => (
        <span
          key={group.handle}
          title={group.ids.join(", ")}
          className="inline-flex items-center gap-1.5 rounded-full bg-ink-100 py-1 pl-1 pr-1 text-[12px] font-medium text-ink-700"
        >
          <CreatorHoverCard handle={group.handle}>
            <span className="inline-flex items-center gap-1.5">
              <CreatorAvatar
                name={group.handle}
                seed={group.handle}
                size={18}
              />
              <span className="line-clamp-1 max-w-[200px]">
                @{group.handle}
              </span>
            </span>
          </CreatorHoverCard>
          <button
            type="button"
            onClick={() =>
              onChange(removeCreatorHandleFromScope(creatorIds, group.handle))
            }
            aria-label={`Remove @${group.handle} from scope`}
            title="Remove — ask all creators"
            className="grid h-5 w-5 shrink-0 place-items-center rounded-full text-ink-500 transition-colors hover:bg-ink-200 hover:text-ink-900"
          >
            <svg
              viewBox="0 0 24 24"
              width="11"
              height="11"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </span>
      ))}
      <button
        type="button"
        onClick={() => onChange([])}
        className="rounded-lg px-1.5 py-1 text-[11px] font-semibold text-ink-500 transition-colors hover:bg-ink-100 hover:text-ink-900"
      >
        Clear all
      </button>
    </div>
  );
}
